export interface Props {
  wrap?: boolean
  wrapper: (child: React.ReactNode) => React.ReactNode
  children: React.ReactNode
}

export default function Wrapper({ wrap = false, wrapper, children }: Props) {
  return <>{wrap ? wrapper(children) : <>{children}</>}</>
}
